import type { SectionSettings } from "@gatsby-plugin-generic-page/fragments/sectionSettings"
import { BG_CLASS } from "@gatsby-plugin-generic-page/fragments/udsBackgroundColor"
import getBackground from "./getBackground"

// A section without a background stays white, as the former HEL default did.
const DEFAULT_SURFACE_CLASS = BG_CLASS["surface-base"]

/**
 * The UDS surface class a section paints, or `undefined` when a custom color
 * paints it instead.
 */
export default function getSectionSurfaceClass(
  sectionSettings: Pick<SectionSettings, "customColor"> | undefined
): string | undefined {
  const { customColor, udsBackgroundColorClass } = getBackground(
    sectionSettings?.customColor
  )

  if (customColor?.background) {
    return undefined
  }

  // `none` maps to an empty class and falls back as well.
  return udsBackgroundColorClass || DEFAULT_SURFACE_CLASS
}
